import {Uuid} from '../uuid';
import {PredictionClass} from '../prediction-class';
import {Confidence} from '../confidence';
import {RikData} from '../rik-data';

export class Prediction {
  uuid: Uuid;
  prediction_class: PredictionClass;
  confidence: Confidence;
  request_new_picture: boolean;

  constructor(data: Prediction) {
    const rikData = new RikData(data);
    this.uuid = rikData.requireExists('uuid');
    this.prediction_class = rikData.getEnumString('prediction_class', PredictionClass);
    this.confidence = rikData.getEnumString('confidence', Confidence);
    this.request_new_picture = rikData.getBool('request_new_picture');
  }
}
